/* eslint-disable
    func-names,
    no-param-reassign,
    no-shadow,
    no-underscore-dangle,
    no-unused-vars,
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
// Collection of all BalanceChecker.
const deps = ['BalanceChecker', 'Collection'];
const factory = function (BalanceChecker, Collection) {
  let BalanceCheckerCollection;
  return (BalanceCheckerCollection = (function () {
    BalanceCheckerCollection = class BalanceCheckerCollection extends Collection {
      static initClass() {
        this.prototype.$id = null;
        this.prototype.$resource = 'balancechecker';
        this.prototype.$type = BalanceChecker;
      }

      $url() {
        return `${super.$url()}/${this.clientId}`;
      }

      $fetch(options = {}, queryParams = {}) {
        if (this.$lastUpdated !== 0 || !this.$resolved) {
          return;
        }

        if (this.year) {
          queryParams.year = this.year;
        }

        const params = {
          url: this.$getUrl(),
          method: this.$method,
          params: queryParams,
        };

        return this.$apiCall(angular.extend(params, options)).then(res =>
          _.reduce(
            res.data.monthlyBalances,
            (balances, obj, id) => {
              const balanceArr = _.map(obj, (balance, month) => balance);

              balances[id] = new BalanceCheckerCollection(id, this.$serialize(balanceArr));
              balances[id].$cacheAllModels();
              return balances;
            },
            {},
          ),
        );
      }

      $findByMonth(month, year) {
        [month, year] = Array.from([Number(month), Number(year)]);
        return this.$find(model => model.month === month && model.year === year);
      }

      $getMonthStatus(month, year) {
        return __guard__(this.$findByMonth(month, year), x => x.getStatus());
      }
    };
    BalanceCheckerCollection.initClass();
    return BalanceCheckerCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/model/balanceChecker').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.balanceChecker', moduleDeps)
  .factory('BalanceCheckerCollection', factory);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
